let UUID = 0;

const UniqueID = function () {
  UUID++;
  return UUID;
};

export default UniqueID;
